import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../setup';
import {
  CreateZatcaIntegrationRequest,
  RenewZatcaIntegrationRequest,
  ZatcaIntegrationStatus,
  ZatcaOnboardingPrefill,
} from '../models/ZatcaIntegration';

interface PaymentsState {
  zatcaIntegrationStatus: ZatcaIntegrationStatus | null;
  isLoadingZatcaIntegrationStatus: boolean;
  zatcaOnboardingPrefill: ZatcaOnboardingPrefill | null;
  isLoadingZatcaOnboardingPrefill: boolean;
  isCreatingZatcaIntegration: boolean;
  isCreateZatcaIntegrationSuccess: boolean;
  createZatcaIntegrationError: string | null;
  isRenewingZatcaIntegration: boolean;
  isRenewZatcaIntegrationSuccess: boolean;
  renewZatcaIntegrationError: string | null;
}

const initialState: PaymentsState = {
  zatcaIntegrationStatus: null,
  isLoadingZatcaIntegrationStatus: false,
  zatcaOnboardingPrefill: null,
  isLoadingZatcaOnboardingPrefill: false,
  isCreatingZatcaIntegration: false,
  isCreateZatcaIntegrationSuccess: false,
  createZatcaIntegrationError: null,
  isRenewingZatcaIntegration: false,
  isRenewZatcaIntegrationSuccess: false,
  renewZatcaIntegrationError: null,
};

const paymentsSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    getZatcaIntegrationStatus(state) {
      state.isLoadingZatcaIntegrationStatus = true;
    },
    getZatcaIntegrationStatusSuccess(state, action: PayloadAction<ZatcaIntegrationStatus>) {
      state.isLoadingZatcaIntegrationStatus = false;
      state.zatcaIntegrationStatus = action.payload;
    },
    getZatcaIntegrationStatusFail(state) {
      state.isLoadingZatcaIntegrationStatus = false;
    },
    getZatcaOnboardingPrefill(state) {
      state.isLoadingZatcaOnboardingPrefill = true;
    },
    getZatcaOnboardingPrefillSuccess(state, action: PayloadAction<ZatcaOnboardingPrefill>) {
      state.isLoadingZatcaOnboardingPrefill = false;
      state.zatcaOnboardingPrefill = action.payload;
    },
    getZatcaOnboardingPrefillFail(state) {
      state.isLoadingZatcaOnboardingPrefill = false;
    },
    createZatcaIntegration(state, _action: PayloadAction<CreateZatcaIntegrationRequest>) {
      state.isCreatingZatcaIntegration = true;
      state.isCreateZatcaIntegrationSuccess = false;
      state.createZatcaIntegrationError = null;
    },
    createZatcaIntegrationSuccess(state, action: PayloadAction<ZatcaIntegrationStatus>) {
      state.isCreatingZatcaIntegration = false;
      state.isCreateZatcaIntegrationSuccess = true;
      state.zatcaIntegrationStatus = action.payload;
    },
    createZatcaIntegrationFail(state, action: PayloadAction<string>) {
      state.isCreatingZatcaIntegration = false;
      state.createZatcaIntegrationError = action.payload;
    },
    resetCreateZatcaIntegrationState(state) {
      state.isCreateZatcaIntegrationSuccess = false;
      state.createZatcaIntegrationError = null;
    },
    renewZatcaIntegration(state, _action: PayloadAction<RenewZatcaIntegrationRequest>) {
      state.isRenewingZatcaIntegration = true;
      state.isRenewZatcaIntegrationSuccess = false;
      state.renewZatcaIntegrationError = null;
    },
    renewZatcaIntegrationSuccess(state, action: PayloadAction<ZatcaIntegrationStatus>) {
      state.isRenewingZatcaIntegration = false;
      state.isRenewZatcaIntegrationSuccess = true;
      state.zatcaIntegrationStatus = action.payload;
    },
    renewZatcaIntegrationFail(state, action: PayloadAction<string>) {
      state.isRenewingZatcaIntegration = false;
      state.renewZatcaIntegrationError = action.payload;
    },
    resetRenewZatcaIntegrationState(state) {
      state.isRenewZatcaIntegrationSuccess = false;
      state.renewZatcaIntegrationError = null;
    },
  },
});

export const paymentsActions = paymentsSlice.actions;

export const selectZatcaIntegrationStatus = (state: RootState) => state.payments.zatcaIntegrationStatus;
export const selectIsLoadingZatcaIntegrationStatus = (state: RootState) => state.payments.isLoadingZatcaIntegrationStatus;
export const selectZatcaOnboardingPrefill = (state: RootState) => state.payments.zatcaOnboardingPrefill;
export const selectIsLoadingZatcaOnboardingPrefill = (state: RootState) => state.payments.isLoadingZatcaOnboardingPrefill;
export const selectIsCreatingZatcaIntegration = (state: RootState) => state.payments.isCreatingZatcaIntegration;
export const selectIsCreateZatcaIntegrationSuccess = (state: RootState) => state.payments.isCreateZatcaIntegrationSuccess;
export const selectCreateZatcaIntegrationError = (state: RootState) => state.payments.createZatcaIntegrationError;
export const selectIsRenewingZatcaIntegration = (state: RootState) => state.payments.isRenewingZatcaIntegration;
export const selectIsRenewZatcaIntegrationSuccess = (state: RootState) => state.payments.isRenewZatcaIntegrationSuccess;
export const selectRenewZatcaIntegrationError = (state: RootState) => state.payments.renewZatcaIntegrationError;

const paymentsReducer = paymentsSlice.reducer;
export default paymentsReducer;
